import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authenticatedGuard } from './core/guards/authenticated.guard';
import { clearStorageGuard } from './core/guards/clear-storage.guard';

const routes: Routes = [
  {
    path: 'enrollment',
    loadChildren: () =>
      import('./pages/enrollment/enrollment.module').then(m => m.EnrollmentModule),
    canActivate: [authenticatedGuard]
  },
  {
    path: '',
    redirectTo: 'enrollment/layout',
    pathMatch: 'full'
  },
  {
    path: 'login',
    canActivate: [clearStorageGuard],
    loadChildren: () =>
      import('./pages/login-gbp/login-gbp.module').then(m => m.LoginGbpModule)
  },
  {
    path: 'movcad',
    loadChildren: () =>
      import('./pages/movcad/movcad.module').then(m => m.MovCadModule),
    canActivate: [authenticatedGuard]
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
